import { KodallClient } from "@kodall/kodall-client"
import * as KodallTypes from "@kodall/kodall-client/dist/types"
// No API key needed in a browser with an existing session
const key = { apiKey: "a240f6ba-8b32-472a-b53b-acc790b10cc9" }
var client = new KodallClient()
// or with an API key
var clientAPIKey = new KodallClient(key)

// Add the interceptor
type KodallResult<T> = T | never;

/**
 * Intercepts Kodall client results and unwraps them safely.
 * - Returns the data if success.
 * - Throws a descriptive error if validation/problem/error.
 */
async function intercept<T>(
  fn: () => Promise<T | T[] | KodallTypes.Validation | KodallTypes.Problem>
): Promise<KodallResult<T>> {
  try {
    const result = await fn();

    if (KodallTypes.isValidation(result)) {
      console.error('Validation error:', result);
      throw new Error(`Kodall Validation: ${JSON.stringify(result, null, 2)}`);
    }

    if (KodallTypes.isProblem(result)) {
      console.error('Kodall problem:', result);
      throw new Error(`Kodall Problem: ${JSON.stringify(result, null, 2)}`);
    }

    return result as T;
  } catch (e) {
    console.error('Kodall client error:', e);
    throw e;
  }
}

export { client, clientAPIKey, KodallTypes, intercept, key }

